/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$scale-xsmall: 0.5;
$scale-small: 0.75;
$scale-large: 1.33;
$scale-xlarge: 2;

:host {
  position: relative;
  color: v(color);
  fill: currentColor;
  display: flex;
}
.#{$prefix}pictogram-wrapper {
  justify-self: center;
  align-self: center;
  position: relative;
  width: 96px;
  height: 96px;
  display: inline-flex;

  svg {
    display: block; // Included due to a MS Edge (pre-chromium) bug.#{$prefix} Icons were displaced inside the button without this.#{$prefix}
    overflow: visible;
    transform-origin: center center;
  }

  &.#{$prefix}x-left {
    justify-content: flex-start;
  }

  &.#{$prefix}x-center {
    justify-content: center;
  }

  &.#{$prefix}x-right {
    justify-content: flex-end;
  }

  &.#{$prefix}y-center {
    align-items: center;
  }

  &.#{$prefix}y-bottom {
    align-items: flex-end;
  }
  &.#{$prefix}xsmall {
    width: 48px;
    height: 48px;
    > svg {
      transform: scale($scale-xsmall);
    }
  }
  &.#{$prefix}small {
    width: 72px;
    height: 72px;
    > svg {
      transform: scale($scale-small);
    }
  }

  @include for-size(desktop-or-larger) {
    &.#{$prefix}large {
      width: 128px;
      height: 128px;
      > svg {
        transform: scale($scale-large);
      }
    }

    &.#{$prefix}xlarge {
      width: 192px;
      height: 192px;
      > svg {
        transform: scale($scale-xlarge);
      }
    }
  }

  &.#{$prefix}no-spacing {
    width: auto;
    &.#{$prefix}xsmall {
      width: calc(var(--pictogramWidth) * #{$scale-xsmall} * 1px);
    }
    &.#{$prefix}small {
      width: calc(var(--pictogramWidth) * #{$scale-small} * 1px);
    }
    @include for-size(desktop-or-larger) {
      &.#{$prefix}large {
        width: calc(var(--pictogramWidth) * #{$scale-large} * 1px);
      }
      &.#{$prefix}xlarge {
        width: calc(var(--pictogramWidth) * #{$scale-xlarge} * 1px);
      }
    }
  }

  &.#{$prefix}x-left.#{$prefix}y-center svg {
    transform-origin: left center;
  }

  &.#{$prefix}x-left.#{$prefix}y-bottom svg {
    transform-origin: left bottom;
  }

  &.#{$prefix}x-center.#{$prefix}y-center svg {
    transform-origin: center center;
  }

  &.#{$prefix}x-center.#{$prefix}y-bottom svg {
    transform-origin: center bottom;
  }

  &.#{$prefix}x-right.#{$prefix}y-center svg {
    transform-origin: right center;
  }

  &.#{$prefix}x-right.#{$prefix}y-bottom svg {
    transform-origin: right bottom;
  }
}
